<template>
    <section class="sear-wrap">
        <h3 class="title">信息流</h3>
        <div class="flex">
            <div class="sear-div-line">
                <span class="sear-title">本地竞争同行 </span>
                <span class="sear-total">{{ queryFeed.zztfPeerNum ? queryFeed.zztfPeerNum : '0' }}家
                    <el-tooltip class="item" effect="dark" content="系统找出投放该关键词且近一年有消费的中小账户作为竞争同行。"
                        placement="top-start">
                        <i class="el-icon-warning"></i>
                    </el-tooltip>
                </span>
            </div>
            <div class="industry-select-wrap">
                <div class="com-div-wrap">
                    <span class="industry-select-title">
                        本地同行太少？试试用行业筛选：
                    </span>
                    <el-select v-model="tradeValue" placeholder="请选择" @change='selectSubTrade' size="small">
                        <el-option v-for="item in tradeList" :key="item.tradeId" :label="item.tradeName"
                            :value="{ value: item.tradeName, label: item.tradeId, subTrade: item.subTrade }">
                        </el-option>
                    </el-select>
                    <el-select v-model="subTradeValue" placeholder="请选择" size="small" @change="clickSubTrade">
                        <el-option v-for="item in subTradeList" :key="item.tradeId" :label="item.tradeName"
                            :value="{ value: item.tradeName, label: item.tradeId }">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="boxContainer">
            <el-row :gutter="10">
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ queryFeed.zztfShwAvg ? queryFeed.zztfShwAvg : '暂无数据' }}</span>
                        <span>户均月展现量</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ queryFeed.zztfClickAvg ? queryFeed.zztfClickAvg : '暂无数据' }}</span>
                        <span>户均月点击量</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ queryFeed.zztfCsmAvg ? queryFeed.zztfCsmAvg : '暂无数据' }}</span>
                        <span>户均月消费</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ queryFeed.zztfClickPrice ? queryFeed.zztfClickPrice : '暂无数据' }}</span>
                        <span>行业平均点击价格</span>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <div class="grid-content">
                        <span>{{ queryFeed.zztfHotProv ? queryFeed.zztfHotProv : '暂无数据' }}</span>
                        <span>热门投放区域</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 同行案例 -->
        <div id="compeSearchCase">
            <h4 class="title">同行案例
                <el-tooltip class="item" effect="dark" content="仅展示所在运营单位开发的本地同行案例数据。" placement="top-start">
                    <i class="el-icon-warning"></i>
                </el-tooltip>
            </h4>
            <div class="search">
                <div class="tabs">
                    <div v-for="tab in tabsArray" :class="`tab ${activeName === tab.name ? 'active' : ''}`"
                        :key="tab.index" @click="clickTabCase(tab)">
                        {{ tab.name }}
                    </div>
                </div>
                <div class="searchContent">
                    <el-input placeholder="公司名、地址" v-model="inputWord" class="input-with-select" size="small">
                        <el-button slot="append" icon="el-icon-search" @click="comNameAddersearch"></el-button>
                    </el-input>
                </div>
            </div>
            <div v-for="(item) in CompanyList" :key="item.index">
                <el-table :data="item.list" style="width: 100%" :cell-style="columnStyle"
                    :default-sort="{ prop: 'renewTimes', order: 'descending' }">
                    <el-table-column prop="custName" label="公司名称" width="220" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="公司地址" width="220" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="legalPerson" label="负责人">
                    </el-table-column>
                    <el-table-column prop="timeTag" label="合作时间">
                    </el-table-column>
                    <el-table-column prop="url" label="网址" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-link type="primary" :href="scope.row.url" target="_blank">{{
                                scope.row.url
                            }}</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="this.CompanyList[0].list.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-size="PageSize" :current-page="page" layout="total, prev, pager, next" :total="totalCount">
                </el-pagination>
            </div>
        </div>
        <!-- 同行优秀创意 -->
        <div id="compeSearchCase">
            <div class="flex">
                <h4 class="title">同行优秀创意</h4>
            </div>
            <el-carousel :interval="4000" type="card">
                <el-carousel-item v-for="item in excellentIdeaData" :key="item">
                    <div class="ideaWarp">
                        <div class="company-name">{{ item.companyName }}</div>
                        <div class="contion flex">
                            <div class="image-boxs">
                                <img :src="picItem" v-for="picItem in item.picUrls" :key="picItem">
                            </div>
                            <div class="idea-info">
                                {{ item.ideaTitle }}
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </section>
</template>
<script>
import { getTrade,getQueryFeed,getFeedPeerInfo,getFeedIdea} from '../utils/request.js'
import { Loading } from 'element-ui'
export default {
    props: ["keyWord", "regionValue"],
    data() {
        return {
            firstTradeId:'',
            inputWord: '',//公司名，地址
            CompanyList: [{ //同行案例
                pageSize: '',
                curPage: '',
                total: '',
                list: []
            }],
            tradeList: [],
            tradeValue: '',
            subTradeValue: '',
            subTradeList: [],
            queryFeed: [{
                peerNum: "",
                showAvg: "",
                csmAvg: "",
                clickAvg: "",
                clickPrice: "",
                zztfClickAvg: "",
                zztfShwAvg: "",
                zztfCsmAvg: "",
                zztfClickPrice: "",
                zztfHotProv: "",
                zhtfClickAvg: "",
                zhtfShwAvg: "",
                zhtfCsmAvg: "",
                zhtfClickPrice: "",
                zhtfHotProv: "",
                zztfPeerNum: "",
                zhtfPeerNum: ""
            }],
            tabsArray: [{ feedType: 0, name: '本地同行', }, { feedType: 1, name: '标杆客户', }],
            feedType:0,
            activeName: '本地同行',
            PageSize: 5, //默认每页显示的条数
            pageSizeHE: 5,
            page: 1, //当前页码
            pageNumHE: 1,
            totalCount: 1, //总条数
            excellentIdeaData: [//优秀案例
            ]
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.selectTrade();//渲染行业数据
        });
    },
    filters: {//小数转化百分比过滤器
        numFilter(value) {
            let realVal = Number(value * 100).toFixed(2)
            return Number(realVal)
        }
    },
    methods: {
        search() {//关键词，区域搜索
            this.page = 1
            this.tradeValue = '';
            this.subTradeValue = ''; //清空行业筛选
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            });
            getQueryFeed(params).then(res => {
                if (res.status == 200) {
                    this.queryFeed = res.data.data
                    loadingInstance.close()
                } else {
                    this.$message.error(res.msg);
                }
            })
            getFeedIdea(params).then(res => {
                if (res.status == 200) {
                    this.excellentIdeaData = res.data.data
                    this.$nextTick(() => {
                        loadingInstance.close()
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        selectTrade() { //获取行业数据
            let params = {
            }
            getTrade(params).then(res => {
                if (res.status == 200) {
                    this.tradeList = res.data.data
                } else {
                    this.$message.error(res.msg);
                }
                console.log(params, 'params')
                console.log(res, 'Trade')
            })
        },
        selectSubTrade(e) {//二级行业筛选
            this.subTradeValue = ''
            let params = {
                trade_first_id: e.label,
            }
            getTrade(params).then(res => {
                if (res.status == 200) {
                    console.log(res, '--------------subTradeList')
                    this.subTradeList = res.data.data
                } else {
                    this.$message.error(res.msg);
                }
                console.log(params, 'params')
                console.log(res, 'Trade')
            })
        },
        clickSubTrade(e) { //点击行业
            this.page = 1
            this.firstTradeId = e.label
            this.XinXiLiu()
            this.HangYeAnli()
            this.YouXiuChuangYi()
        },
        comNameAddersearch() { //公司名，地址筛选
            // console.log(this.inputWord, 'comNameAddersearch')
            this.page = 1
            this.HangYeAnli()
        },
        clickTabCase(tab) {//同行案例类型选择
            this.activeName = tab.name;
            this.page = 1
            // this.updateTab();
            this.feedType = tab.feedType
            console.log(this.feedType, '同行案例类型选择')
            if (this.subTradeList.length > 0 || this.CompanyList[0].list.length > 0 || this.keyWord.length > 0) {
                this.HangYeAnli()
            }
        },
        // 信息流主要信息查询
        XinXiLiu() {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            });
            getQueryFeed(params).then(res => {
                if (res.status == 200) {
                    this.queryFeed = res.data.data
                    // console.log(res.data.data, '信息流主要信息')
                    loadingInstance.close()
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        //信息流同行案例
        HangYeAnli(n1) {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
                page_size: 5,
                page_num: n1,
                feed_type: this.feedType,
                input_word: this.inputWord
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            })
            getFeedPeerInfo(params).then(res => {
                if (res.status == 200) {
                    this.CompanyList[0].list = res.data.data.list
                    this.totalCount = res.data.data.total
                    // console.log(this.totalCount, '------------------totalCount')
                    console.log(this.CompanyList[0], '信息流同行案例')
                    this.$nextTick(() => {
                        loadingInstance.close()
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        //信息流同行优秀创意
        YouXiuChuangYi() {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            })
            getFeedIdea(params).then(res => {
                if (res.status == 200) {
                    this.excellentIdeaData = res.data.data
                    console.log(res.data.data, '同行优秀创意')
                    this.$nextTick(() => {
                        loadingInstance.close()
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 改变Table某一列的背景颜色
        // columnIndex为列下标
        columnStyle({ row, column, rowIndex, columnIndex }) {
            console.log(row)
            console.log(column)
            console.log(rowIndex)
            if (columnIndex == 3) {
                //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                return 'color:#ff8e00'
            }
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`)
            // this.page=val
            // this.HangYeAnli(val,1)
            this.currentPage = 1
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`)
            this.page = val
            // 切换页码时，要获取每页显示的条数
            this.HangYeAnli(this.page)
        },
    },

}

</script>

<style scoped lang="less">
@import "../assets/reset.less";

.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title {
    position: relative;
    padding-left: 15px;

    &::before {
        position: absolute;
        content: '';
        height: 20px;
        width: 5px;
        background-color: @Color8;
        top: 50%;
        margin-top: -10px;
        left: 0px;
    }
}

.sear-div-line {
    display: flex;
    align-items: center;
    color: @Color10;
    font-size: 14px;

    .sear-total {
        color: @Color8;
        font-size: 24px;
        margin-left: 5px;

        i {
            font-size: 14px;
        }
    }
}

.industry-select-wrap {
    display: flex;
    align-items: center;
    color: @Color10;
    font-size: 14px;

    .com-div-wrap {
        .el-select {
            margin-left: 5px;
        }
    }
}

.boxContainer {
    margin-top: 20px;

    .el-col-6 {
        .grid-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1.6em;
            padding: 10px;
            color: #fff;
            font-size: 16px;
        }

        &:nth-child(1) .grid-content {
            background-color: @Color2;
        }

        &:nth-child(2) .grid-content {
            background-color: @Color3;
        }

        &:nth-child(3) .grid-content {
            background-color: @Color4;
        }

        &:nth-child(4) .grid-content {
            background-color: @Color5;
        }
    }

    .el-col-12 {
        margin-top: 10px;

        .grid-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1.6em;
            padding: 10px;
            color: @Color8;
            font-size: 16px;
            background-color: @Color11;
        }

    }
    .el-col-24 {
        margin-top: 10px;

        .grid-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1.6em;
            padding: 10px;
            color: @Color8;
            font-size: 16px;
            background-color: @Color11;
        }

    }
}

#compeSearchCase {
    margin-top: 40px;
    margin-bottom: 80px;
}

h4.title {
    &::before {
        background-color: @Color6;
    }

    i {
        color: @Color8;
        font-size: 14px;
    }
}

.search {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.el-pagination {
    text-align: right;
    margin: 10px 0px;
}

.download {
    font-size: 14px;
    color: @Color7;
}

.tabs {
    display: flex;
    align-items: center;

    .tab {
        border: 1px solid #eee;
        background-color: #f9f9f9;
        margin-right: 15px;
        width: 76px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #333;
        font-size: 14px;
        cursor: pointer;
    }

    .active {
        background-color: #fdb050;
        border: 1px solid #fdb050;
        color: #fff;
    }
}

.rank-h-title {
    display: block;
    font-size: 16px;
    color: @Color6;
    margin-bottom: 10px;
}

.calcLine {
    position: relative;
    top: -1px;
    margin-left: 2px;
    display: inline-block;
    height: 5px;
    background-color: #00d7db;
    vertical-align: middle;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}

.el-carousel__item{
    border: 1px solid #ddd;
    border-radius: 20px;
    background-color: #fff;
}

.ideaWarp {
    padding: 20px;
    height: 350px;
    overflow: hidden;
    .company-name {
        font-size: 16px;
        margin-bottom: 20px;
    }
    .contion {
        .image-boxs {
            width: 220px;
            margin-right: 20px;
            img{
                width: calc(100%/2 - 10px);
                height: 100px;
                margin-right: 5px;
            }
        }
        .idea-info {
            flex: 1;
            text-align: justify;
            font-size: 14px;
            color: @Color10;
        }
    }
}
</style>
